<template>
  <div class="ColorPickerButton">
    <UiIcon
      class="ColorPickerButton__trigger ToolbarButton"
      :value="$attrs.icon"
      v-bind="$attrs"
      @click="togglePopup"
    />

    <div
      v-show="!!value"
      class="ColorPickerButton__badge"
      :style="{backgroundColor: value}"
    ></div>

    <div
      ref="popup"
      class="ColorPickerButton__popup"
      v-if="isOpen"
    >
      <div
        v-for="color in colors"
        :key="color"
        @click="selectColor(color)"
        class="ColorPickerButton__box"
        :style="{ backgroundColor: color }"
      >
        <span
          v-if="value === color"
          class="ColorPickerButton__box_checkmark"
          :style="{ color: value == '#FFFFFF' ? 'black' : 'white' }"
        >✔</span>
      </div>

      <div
        class="ColorPickerButton__box"
        @click="selectColor(null)"
        title="Clear"
      >
        &times;
      </div>
    </div>
  </div>
</template>

<script>
import { UiIcon } from '@/modules/ui/components';

export default {
  inheritAttrs: false,
  components: { UiIcon },

  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      isOpen: false,
      colors: [
        '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FFA500',
        '#FFC0CB', '#800080', '#808080', '#A52A2A', '#808000',
        '#40E0D0', '#00FFFF', '#FF00FF', '#C0C0C0', '#FFD700',
        '#E6E6FA', '#000080', '#006400', '#000000', '#FFFFFF',
      ],
    };
  },

  mounted() {
    document.addEventListener('click', this.closePopup);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closePopup);
  },

  methods: {
    togglePopup() {
      this.isOpen = !this.isOpen;
    },

    selectColor(color) {
      this.isOpen = false;
      this.$emit('input', color);
    },

    closePopup(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
};
</script>

<style lang="scss">
.ColorPickerButton {
  position: relative;

  &__badge {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    pointer-events: none;
    position: absolute;
    top: 6px;
    right: 6px;
  }

  &__popup {
    position: absolute;
    z-index: 10;
    width: 180px;
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__box {
    margin: 5px;
    width: 25px;
    height: 25px;
    display: flex;
    cursor: pointer;
    align-items: center;
    border: 1px solid #ccc;
    justify-content: center;
  }
}

@media screen and (max-width: 450px) and (min-width: 320px) {
  .ColorPickerButton {
    &__popup {
      right: 0px;
    }
  }
}

@media screen and (max-width: 742px) and (min-width: 626px) {
  .ColorPickerButton {
    &__popup {
      right: 0px;
    }
  }
}
</style>